import React from 'react';

class RowItemGQDKN extends React.Component {

  render() {
    let Item = this.props.item;
    let data = Item ? Item.soLieuBaoCaoInfo : {};
    return (
      <tr className={this.props.sum ? 'txt-bold' : ''}>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='column-name-fixed'>{data.tenDonVi}</td>

        <td className='txt-center'>{data.tongSoDonKhieuNai}</td>
        <td className='txt-center'>{data.donNhanTrongKyBaoCao}</td>
        <td className='txt-center'>{data.donTonKyTruocChuyenSang}</td>
        <td className='txt-center'>{data.tongSoVuViec}</td>
        <td className='txt-center'>{data.soDonThuocThamQuyen}</td>
        <td className='txt-center'>{data.soVuViecThuocThamQuyen}</td>
        <td className='txt-center'>{data.soVuViecGiaiQuyetBangQDHanhChinh}</td>
        <td className='txt-center'>{data.soVuViecRutDonThongQuaGiaiThichThuyetPhuc}</td>
        <td className='txt-center'>{data.khieuNaiDung}</td>
        <td className='txt-center'>{data.khieuNaiSai}</td>
        <td className='txt-center'>{data.khieuNaiDungMotPhan}</td>
        <td className='txt-center'>{data.giaiQuyetLan1}</td>
        <td className='txt-center'>{data.congNhanQuyetDinhGiaiQuyetLan1}</td>
        <td className='txt-center'>{data.huySuaQuyetDinhGiaiQuyetLan1}</td>
        <td className='txt-center'>{data.kienNghiThuHoiChoNhaNuocTien}</td>
        <td className='txt-center'>{data.kienNghiThuHoiChoNhaNuocDat}</td>
        <td className='txt-center'>{data.traLaiChoCongDanTien}</td>
        <td className='txt-center'>{data.traLaiChoCongDanDat}</td>
        <td className='txt-center'>{data.soNguoiDuocTraLaiQuyenLoi}</td>
        <td className='txt-center'>{data.kienNghiXuLyHanhChinhTongSoNguoi}</td>
        <td className='txt-center'>{data.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy}</td>
        <td className='txt-center'>{data.soVuChuyenCoQuanDieuTra}</td>
        <td className='txt-center'>{data.soDoiTuongChuyenCoQuanDieuTra}</td>
        <td className='txt-center'>{data.soVuDaKhoiTo}</td>
        <td className='txt-center'>{data.soDoiTuongDaKhoiTo}</td>
        <td className='txt-center'>{data.soVuViecGiaiQuyetDungThoiHan}</td>
        <td className='txt-center'>{data.soVuViecGiaiQuyetQuaThoiHan}</td>
        <td className='txt-center'>{data.tongSoQuyetDinhPhaiToChucThucHien}</td>
        <td className='txt-center'>{data.tongSoQuyetDinhPhaiToChucThucHienDaThucHien}</td>
        <td className='txt-center'>{data.tienPhaiThuChoNhaNuoc}</td>
        <td className='txt-center'>{data.datPhaiThuChoNhaNuoc}</td>
        <td className='txt-center'>{data.tienDaThuChoNhaNuoc}</td>
        <td className='txt-center'>{data.datDaThuChoNhaNuoc}</td>
        <td className='txt-center'>{data.tienPhaiTraChoCongDan}</td>
        <td className='txt-center'>{data.datPhaiTraChoCongDan}</td>
        <td className='txt-center'>{data.tienDaTraChoCongDan}</td>
        <td className='txt-center'>{data.datDaTraChoCongDan}</td>
        <td className='ghi-chu'>{data.ghiChu}</td>
      </tr>
    );
  }
}

export default RowItemGQDKN;


// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-tong-hop/datatable/RowItemGQDKN.jsx